import React, { useState } from "react";

export default function FaqAccordion({ isGold, title, items = [] }) {
    const [openIndex, setOpenIndex] = useState(0);

    if (!items.length) return null;

    return (
        <div className="border border-zinc-300 rounded-lg overflow-hidden">
            {title && (
                <div className="flex items-center gap-2 px-4 py-3 bg-[#EEF3FB] border-b border-zinc-300">
                    <span className="w-1 h-4 bg-red-600 rounded-sm" />
                    <h2 className="text-[16px] font-bold text-gray-900">{title}</h2>
                </div>
            )}

            {items.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                    <div key={index} className={`border-b last:border-none ${isOpen ? isGold ? "bg-[#FFFDF5]" : "bg-[#F8F9FB99]" : ""}`}>
                        <button
                            type="button"
                            onClick={() => setOpenIndex(isOpen ? -1 : index)}
                            className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left"
                        >
                            <span className={`text-sm font-semibold ${isOpen ? "text-red-600" : "text-gray-800"}`}>
                                {item.q}
                            </span>
                            <span
                                className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-sm font-bold ${isOpen ? "bg-red-100 text-red-600" : "bg-gray-100 text-gray-600"
                                    }`}
                            >
                                {isOpen ? "−" : "+"}
                            </span>
                        </button>
                        {isOpen && (
                            <div className="px-4 pb-4 text-sm text-gray-500 leading-relaxed">
                                {item.a}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
